import { call, fork, put, takeLatest } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';
import {
    subscribeFailure,
    subscribeSuccess,
    subscribeToPlanningBoardEventsFailure,
    subscribeToPlanningBoardEventsSuccess,
    unsubscribeFailure,
    unsubscribeSuccess,
    unsubscribeToPlanningBoardEventsFailure,
    unsubscribeToPlanningBoardEventsSuccess,
} from './socket-actions';

export function* doSubscribe(action) {
    try {
        const { entityId, connectionId } = action.payload;
        const options = {
            endpoint: 'events/subscriptions/entity',
            options: {
                method: 'POST',
                body: JSON.stringify({
                    entityId,
                    connectionId,
                }),
                errorMessage: `Could not subscribe to ${connectionId}`,
                retryAction: action,
            },
        };
        const results = yield call(callApi, options);

        yield put(subscribeSuccess({
            ...results,
            entityId,
        }));
    } catch (err) {
        yield put(subscribeFailure({
            ...err,
            entityId: action.payload.entityId,
        }));
    }
}

export function* doUnsubscribe(action) {
    try {
        const { entityId, connectionId } = action.payload;
        const options = {
            endpoint: 'events/subscriptions/entity',
            options: {
                method: 'DELETE',
                body: JSON.stringify({
                    entityId,
                    connectionId,
                }),
                errorMessage: `Could not subscribe to ${connectionId}`,
                retryAction: action,
            },
        };
        const results = yield call(callApi, options);
        yield put(unsubscribeSuccess({
            ...results,
            entityId,
        }));
    } catch (err) {
        yield put(unsubscribeFailure({
            ...err,
            entityId: action.payload.entityId,
        }));
    }
}

export function* doSubscribeToPlanningboardEvents(action) {
    const {
        viewId,
        start,
        connectionId,
        sessionId,
        previousStart,
        previousViewId,
    } = action.payload;

    let body = {
        viewId,
        start,
        connectionId,
    };
    if (previousStart) {
        body = {
            ...body,
            previousStart,
        };
    }
    if (previousViewId) {
        body = {
            ...body,
            previousViewId,
        };
    }

    try {
        yield call(callApi, {
            endpoint: 'events/subscriptions/planningboard',
            options: {
                method: 'POST',
                body: JSON.stringify(body),
                errorMessage: 'Subscription to planningboard events failed',
                retryAction: action,
            },
        });
        yield put(subscribeToPlanningBoardEventsSuccess(
            `${viewId}_${start}_${connectionId}_${sessionId}`,
        ));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        yield put(subscribeToPlanningBoardEventsFailure(
            `${viewId}_${start}_${connectionId}_${sessionId}`,
        ));
    }
}

export function* doUnsubscribeToPlanningboardEvents(action) {
    const {
        viewId,
        start,
        connectionId,
        sessionId,
    } = action.payload;

    const body = {
        viewId,
        start,
        connectionId,
    };
    try {
        yield call(callApi, {
            endpoint: 'events/subscriptions/planningboard',
            options: {
                method: 'DELETE',
                body: JSON.stringify(body),
                errorMessage: 'UnSubscribe to planningboard events failed',
                retryAction: action,
            },
        });
        yield put(unsubscribeToPlanningBoardEventsSuccess(
            `${viewId}_${start}_${connectionId}_${sessionId}`,
        ));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        yield put(unsubscribeToPlanningBoardEventsFailure(
            `${viewId}_${start}_${connectionId}_${sessionId}`,
        ));
    }
}

function* watchSubscribe() {
    yield takeLatest(actionTypes.SUBSCRIBE, doSubscribe);
}

function* watchUnsubscribe() {
    yield takeLatest(actionTypes.UNSUBSCRIBE, doUnsubscribe);
}

function* watchSubscribeToPlanningboard() {
    yield takeLatest(actionTypes.SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST,
        doSubscribeToPlanningboardEvents);
}

function* watchUnsubscribeToPlanningboard() {
    yield takeLatest(actionTypes.UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST,
        doUnsubscribeToPlanningboardEvents);
}

export default [
    fork(watchSubscribe),
    fork(watchUnsubscribe),
    fork(watchSubscribeToPlanningboard),
    fork(watchUnsubscribeToPlanningboard),
];
